import React, { FC } from 'react'
import { ArticleNode, GetSlug } from '../../utils/core';
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"
import { Link, useTranslation } from "../../plugins/i18next/ea-react-i18next";

export const OtherSuccessStories: FC<{ successStories: ArticleNode[]; currentSlug: string; }> = ({ successStories: successStories, currentSlug }) => {
  const { t } = useTranslation("components", { keyPrefix: 'successStories.otherSuccessStories' });
  
  const filteredSuccessStories = successStories.filter((successStory) => {
    // Destructure for easier access
    const { slug } = successStory.frontmatter;
    //const { language } = successStory.fields;

    // Filter conditions
    return slug !== currentSlug;// && language === currentLanguage;
  });

  return (
    <div className="container-fluid hero-container">      
    <h3 className="successstory-other-title">{t("title")}</h3>
      <div className="row successstory-other">   
  
        {filteredSuccessStories.map((successstory, idx) => {
          const { frontmatter } = successstory;
          const { title, slug, blogimage, category } = frontmatter;
          return (
            <div className="col-lg-4 col-md-6" key={idx}>
              <div className="single-successstory-post bg-fffbf5">
                <div className="successstory-image">
                  <Link to={GetSlug(category, slug)}>
                    <GatsbyImage
                      alt={blogimage?.alternativeText ?? "slurp"}
                      image={blogimage?.childImageSharp?.gatsbyImageData as unknown as IGatsbyImageData}
                    />
                  </Link>
                </div>
                <div className="successstory-other-content">
                  <p>
                    <Link to={GetSlug(category, slug)}>{title}</Link>
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
